import { render, staticRenderFns } from "./task-summary.vue?vue&type=template&id=283c597a&scoped=true"
import script from "./task-summary.vue?vue&type=script&lang=js"
export * from "./task-summary.vue?vue&type=script&lang=js"
import style0 from "./task-summary.vue?vue&type=style&index=0&id=283c597a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c597a",
  null
  
)

export default component.exports